(function() {
    'use strict';
    /**
     * @namespace Holds specific functions/helpers to the flights application.
     * The main purpose is to avoid code duplicity among flows.
     */

    window.App = Odigeo.extendNamespace(window.App, 'Flights');
    var Flights = App.Flights;
    const tv4 = window.tv4 = window.tv4 || require('third-party/tv4.min');
    var SEARCH = {
        PARAMS_PARSER: {
            'class': 'cabinClass',
            'direct': 'directFlightsOnly',
            'resident': 'resident',
            'adults': 'numAdults',
            'children': 'numChildren',
            'infants': 'numInfants',
            'kid0Age': 'kid0Age',
            'kid1Age': 'kid1Age',
            'kid2Age': 'kid2Age',
            'kid3Age': 'kid3Age',
            'kid4Age': 'kid4Age',
            'kid5Age': 'kid5Age',
            'infant0Age': 'infant0Age',
            'infant1Age': 'infant1Age',
            'infant2Age': 'infant2Age',
            'infant3Age': 'infant3Age',
            'collectionmethod': 'collectionMethod',
            'airlinescodes': 'airlinesCodes',
            'fareItineraryKey': 'fareItineraryKey',
            'searchId': 'searchId',
            'buyPath': 'buyPath',
            'internalSearch': 'internalSearch',
            'landingPageType': 'landingPageType',
            'flexibleDates': 'flexibleDates',
            'mainairports': 'mainAirportsOnly',
        },
        PARAMS_STRINGIFY: {
            type: 'type',
            searchSegments: 'searchSegments',
            directFlightsOnly: 'direct',
            resident: 'resident',
            cabinClass: 'class',
            numAdults: 'adults',
            numChildren: 'children',
            numInfants: 'infants',
            kid0Age: 'kid0Age',
            kid1Age: 'kid1Age',
            kid2Age: 'kid2Age',
            kid3Age: 'kid3Age',
            kid4Age: 'kid4Age',
            kid5Age: 'kid5Age',
            infant0Age: 'infant0Age',
            infant1Age: 'infant1Age',
            infant2Age: 'infant2Age',
            infant3Age: 'infant3Age',
            collectionMethod: 'collectionmethod',
            airlinesCodes: 'airlinescodes',
            internalSearch: 'internalSearch',
            flexibleDates: 'flexibleDates',
            mainAirportsOnly: 'mainairports',
        },
        TYPES: {
            'O': 'oneWayTrip',
            'R': 'roundTrip',
            'M': 'multipleTrip',
        },
    };
    var fillSegmentKey = function(idx, value, search) {
        ensureSegmentKeys(search);
        search.externalSelectionRequest.segmentKeys[idx] = value;
    };
    var ensureSegmentKeys = function(search) {
        if (_.isUndefined(search.externalSelectionRequest.segmentKeys)) {
            search.externalSelectionRequest.segmentKeys = [];
        }
    };

    Flights.searchParamsDefaults = {
        'cabinClass': 'TOURIST',
        'directFlightsOnly': false,
        'numAdults': 1,
        'numChildren': 0,
        'numInfants': 0,
    };

    Flights.searchParamsAgeSelector = {
        'kid0Age': 0,
        'kid1Age': 0,
        'kid2Age': 0,
        'kid3Age': 0,
        'kid4Age': 0,
        'kid5Age': 0,
        'infant0Age': 0,
        'infant1Age': 0,
        'infant2Age': 0,
        'infant3Age': 0,
    };

    Flights.composeParametrizedDate = function(type, value, depDate) {
        var date;
        var datePlusOffset;
        var splitDate;
        var formatDate = function(date) {
            var day = date.getDate();
            var month = date.getMonth() + 1;
            var year = date.getFullYear();

            return year + '-' + (10 > month ? '0' + month : month) + '-' + (10 > day ? '0' + day : day);
        };

        if ('dep' === type) {
            date = new Date();
        } else {
            splitDate = depDate.split('-');
            date = new Date(splitDate[0], splitDate[1] - 1, splitDate[2]);
        }
        datePlusOffset = date.getDate() + parseInt(value, 10);
        date.setDate(datePlusOffset);
        return formatDate(date);
    };

    Flights.searchParamsParser = function(p, keyParams) {
        var params = decodeURI(p);
        var data = Odigeo.Utils.parseHashParameters(params);
        var keyMap = _.extend({}, SEARCH.PARAMS_PARSER, keyParams);
        var search = _.clone(App.Flights.searchParamsDefaults);
        var fillSegment;
        var fillSegmentParametrizedDates;
        var re;

        if (Odigeo.AB.isOfferChildrenAgeDesktop) {
            search = _.extend(search, App.Flights.searchParamsAgeSelector);
        }
        search.searchSegments = [];
        search.externalSelectionRequest = {};

        fillSegment = function(type, idx, value, key) {
            var segment;
            var location;
            var keyMap = {
                'from': 'departure',
                'to': 'destination',
                'timewindow': 'timeWindow',
                'time': 'time',
            };

            segment = search.searchSegments[idx] || {};

            switch (type) {
                case 'from':
                case 'to':
                    location = segment[keyMap[type]] || {};
                    if (!key) {
                        if (value.match(/^\d+$/)) {
                            location.geoNodeId = value;
                        } else {
                            location.iata = value;
                        }
                    } else {
                        if ('id' === key) {
                            key = 'geoNodeId';
                        }
                        location[key] = value;
                    }
                    segment[keyMap[type]] = location;
                    break;
                case 'dep':
                case 'ret':
                    if (key) {
                        segment[keyMap[key]] = value;
                    } else {
                        segment.dateStr = value;
                    }
                    break;
            }

            search.searchSegments[idx] = segment;
        };

        search.type = SEARCH.TYPES[data.type];

        // Fill the trivial values
        _.each(_.omit(data, 'type'), function(val, key) {
            var value;
            switch (key) {
                case 'resident':
                case 'direct':
                case 'buyPath':
                case 'landingPageType':
                case 'internalSearch':
                case 'mainairports':
                    switch (val) {
                        case '':
                        case 'false':
                            value = false;
                            break;
                        case 'true':
                            value = true;
                            break;
                        default:
                            value = val;
                    }
                    search[keyMap[key]] = value;
                    break;
                case 'flexibleDates':
                    search[keyMap[key]] = ('true' === val);
                    break;
                case 'kid0Age':
                case 'kid1Age':
                case 'kid2Age':
                case 'kid3Age':
                case 'kid4Age':
                case 'kid5Age':
                case 'infant0Age':
                case 'infant1Age':
                case 'infant2Age':
                case 'infant3Age':
                    value = parseInt(val, 10);
                    if (!_.isNaN(value)) {
                        search[key] = value;
                    }
                    break;
                case 'adults':
                case 'children':
                case 'infants':
                case 'collectionmethod':
                    value = parseInt(val, 10);
                    if (!_.isNaN(value)) {
                        search[keyMap[key]] = value;
                    }
                    break;
                case 'airlinescodes':
                    switch (val) {
                        case '':
                        case 'false':
                            break;
                        default:
                            search[keyMap[key]] = val.split(',');
                    }
                    break;
                case 'class':
                    search[keyMap[key]] = val;
                    break;
                case 'segmentKey0':
                    fillSegmentKey(0, val, search);
                    break;
                case 'segmentKey1':
                    fillSegmentKey(1, val, search);
                    break;
                case 'fareItineraryKey':
                    search.externalSelectionRequest.fareItineraryKey = val;
                    break;
            }
        });

        fillSegmentParametrizedDates = function(type, idx, value) {
            fillSegment(type, idx, Flights.composeParametrizedDate(type, value, search.searchSegments[0].dateStr));
        };

        switch (search.type) {
            case 'oneWayTrip':
                re = /^(from|to|dep|X)(\d+)?(\.([a-zA-Z]+))?$/;
                _.each(data, function(val, key) {
                    var result = re.exec(key);
                    if (!_.isNull(result)) {
                        switch (result[1]) {
                            case 'X':
                                fillSegmentParametrizedDates('dep', 0, val);
                                break;
                            default:
                                fillSegment(result[1], result[2] || 0, val, result[4]);
                                break;
                        }
                    }
                });
                break;
            case 'multipleTrip':
                re = /^(from|to|dep)(\d+)?(\.([a-zA-Z]+))?$/;
                _.each(data, function(val, key) {
                    var result = re.exec(key);
                    if (!_.isNull(result)) {
                        fillSegment(result[1], result[2] || 0, val, result[4]);
                    }
                });
                break;
            case 'roundTrip':
                re = /^(from|to|dep|ret|X|Y)(\.([a-zA-Z]+))?$/;
                _.each(data, function(val, key) {
                    var result = re.exec(key);
                    if (!_.isNull(result)) {
                        switch (result[1]) {
                            case 'from':
                                fillSegment('from', 0, val, result[3]);
                                fillSegment('to', 1, val, result[3]);
                                break;
                            case 'to':
                                fillSegment('from', 1, val, result[3]);
                                fillSegment('to', 0, val, result[3]);
                                break;
                            case 'dep':
                                fillSegment('dep', 0, val, result[3]);
                                break;
                            case 'ret':
                                fillSegment('ret', 1, val, result[3]);
                                break;
                            case 'X':
                                fillSegmentParametrizedDates('dep', 0, val);
                                break;
                            case 'Y':
                                fillSegmentParametrizedDates('ret', 1, val);
                                break;
                        }
                    }
                });
                break;
        }

        // we add the MAPI part if necessary
        Flights.addMapiParamsToSearch(search, Odigeo.Utils.decodeParams(window.location.search.substring(1)));

        return search;
    };

    Flights.addMapiParamsToSearch = function(searchObj, params) {
        var re = /^(segmentKey)(\d+)?(\.([a-zA-Z]+))?$/;
        if (!_.isUndefined(params.segmentKey0)) {
            searchObj.externalSelectionRequest.searchId = params.searchId;
            searchObj.externalSelectionRequest.fareItineraryKey = params.fareItineraryKey;

            _.each(params, function(val, key) {
                var result = re.exec(key);
                if (!_.isNull(result)) {
                    fillSegmentKey(result[2], val, searchObj);
                }
            });
        }
    };

    Flights.completeWithGeographicInformation = function(data) {
        var dfd = $.Deferred();
        var locations;
        var request;
        var iatas = [];
        var geoNodes = [];
        var completed = _.clone(data);
        var query;
        var attributes = ['dateStr', 'time', 'timeWindow'];

        // Extract locations
        locations = _.chain(data.searchSegments)
            .map(_.flowRight(_.values, _.partial(_.omit, _, attributes)))
            .flatten()
            .value();

        // Collect queries
        _.each(locations, function(loc) {
            if (_.has(loc, 'geoNodeId')) {
                geoNodes.push(loc.geoNodeId);
            } else if (_.has(loc, 'iata')) {
                iatas.push(loc.iata);
            }
        });

        // Filter queries
        iatas = _.uniq(iatas);
        geoNodes = _.uniq(geoNodes);

        // Build querystring
        query = _.map(iatas, function(iata) {
            return 'iatas=' + iata;
        }).concat(_.map(geoNodes, function(geoNode) {
            return 'ids=' + geoNode;
        })).join(';');

        if (query) {
            request = $.ajax({
                url: Odigeo.Settings.options.geoServiceUrlFormatter('locations') + ';' + query,
                dataType: 'json',
                method: 'GET',
            });

            request.then(function(response) {
                if (!response.length) {
                    dfd.reject('WRONG_SEARCH');
                }

                // Fill in the blanks
                var segments = _.map(data.searchSegments, function(segment) {
                    _.each(segment, function(loc, type, segment) {
                        var fullData;

                        if (!_.includes(attributes, type)) {
                            if (_.includes(iatas, loc.iata)) {
                                fullData = _.find(response, _.matches({'iata': loc.iata}));
                            } else if (_.includes(geoNodes, loc.geoNodeId)) {
                                fullData = _.find(response, _.matches({'geoNodeId': parseInt(loc.geoNodeId, 10)}));
                            }

                            if (fullData) {
                                loc = _.defaults(loc, fullData);
                            } else {
                                dfd.reject('WRONG_SEARCH');
                            }
                        }
                        segment[type] = loc;
                    });

                    return segment;
                });

                completed.searchSegments = segments;

                dfd.resolve(completed);
            }, function(response) {
                dfd.reject('WRONG_SEARCH', response);
            });
        } else {
            dfd.resolve(completed);
        }

        return dfd.promise();
    };

    Flights.getPath = function(options) {
        return Odigeo.Utils.templateLiteral('${host}${path}/${flightData}#${page}/${searchParams}', {
            host: location.hostname,
            path: Odigeo.Settings.getProperty('appContext'),
            page: options.page || Odigeo.History.getPageNameFromFragment(),
            flightData: options.flightData,
            searchParams: options.searchParams,
        });
    };

    Flights.searchParamsStringify = function(params, keyParams) {
        var accSearchParams = '';
        var flightSearchParams = Flights.stringifiedURLParams(_.extend({}, params, accSearchParams.updatedParamObj), keyParams);
        if (Odigeo.AB.isOfferChildrenAgeDesktop) {
            accSearchParams = Flights.stringifyChildAges(params);
            flightSearchParams += ';' + accSearchParams.stringifiedParams;
        }
        return flightSearchParams;
    };

    Flights.stringifyChildAges = function(params) {
        var finalPassengersNum = {};
        var normalizedObj = Flights.normalizeParamsObject(params, finalPassengersNum);
        return {
            updatedParamObj: _.extend(params, finalPassengersNum),
            stringifiedParams: _.chain(normalizedObj)
                .reduce(function(memo, val, key) {
                    return memo + key + '=' + val + ';';
                }, '')
                .tap(encodeURI)
                .value()
                .slice(0, -1),
        };
    };

    Flights.normalizeParamsObject = function(params) {
        var agesMap = _.extend({}, params.kids, params.infants);
        return pickKidAndInfantAges(agesMap, params.numChildren, params.numInfants);
    };

    function pickKidAndInfantAges(params, numChildren, numInfants) {
        return _.reduce(params, function(memo, age, key) {
            if (isValidKey(key, numChildren, numInfants)) {
                memo[key] = age;
            }
            return memo;
        }, {});
    }

    function isValidKey(key, numChildren, numInfants) {
        var numKid = getTravellerAge('kid', key);
        var numInfant = getTravellerAge('infant', key);
        if (0 <= numKid) {
            return numKid < numChildren;
        } else if (0 <= numInfant) {
            return numInfant < numInfants;
        }
        return false;
    }

    function getTravellerAge(type, key) {
        var stringAge = (new RegExp('^' + type + '(\\d+)Age$').exec(key) || [])[1];
        return _.isUndefined(stringAge) ? -1 : _.parseInt(stringAge);
    }
    Flights.stringifiedURLParams = function(params, keyParams) {
        // Order of this array affects order of the parameters in the string
        var keyMap = _.extend({}, SEARCH.PARAMS_STRINGIFY, keyParams);
        var typeMap = _.invert(SEARCH.TYPES);
        var pickedParams = _.pick(params, _.keys(keyMap));
        var defaultPassengers = 1 === params.numAdults &&
                0 === params.numChildren &&
                0 === params.numInfants;
        return _.chain(pickedParams)
            .reduce(function(memo, val, key) {
                var data;

                switch (key) {
                    case 'searchSegments':
                        return memo + ';' + _.chain(val)
                            .map(function(seg, idx) {
                                var dep = 'dep';
                                var ret = 'ret';
                                var from = 'from';
                                var to = 'to';
                                var time = '.time';
                                var timeWindow = '.timewindow';
                                var fromVal = seg.departure.iata || seg.departure.geoNodeId;
                                var toVal = seg.destination.iata || seg.destination.geoNodeId;
                                var searchSegments = [];

                                if ('roundTrip' === params.type && 1 === idx) {
                                    searchSegments.push(ret + '=' + seg.dateStr);
                                    if (seg.time) {
                                        searchSegments.push(ret + time + '=' + seg.time);
                                    }
                                    if (seg.timeWindow) {
                                        searchSegments.push(ret + timeWindow + '=' + seg.timeWindow);
                                    }
                                    return searchSegments;
                                }
                                if ('multipleTrip' === params.type) {
                                    dep += String(idx);
                                    from += String(idx);
                                    to += String(idx);
                                }

                                searchSegments.push(dep + '=' + seg.dateStr);
                                searchSegments.push(from + '=' + fromVal);
                                searchSegments.push(to + '=' + toVal);

                                if (seg.time) {
                                    searchSegments.push(dep + time + '=' + seg.time);
                                }
                                if (seg.timeWindow) {
                                    searchSegments.push(dep + timeWindow + '=' + seg.timeWindow);
                                }

                                return searchSegments;
                            })
                            .flatten()
                            .value()
                            .join(';');
                    case 'type':
                        data = typeMap[val];
                        break;
                    case 'numAdults':
                    case 'numChildren':
                    case 'numInfants':
                        if (!defaultPassengers && 0 !== val) {
                            data = String(val);
                        } else {
                            return memo;
                        }
                        break;
                    default:
                        if (val === App.Flights.searchParamsDefaults[key]) {
                            return memo;
                        }
                        data = String(val) || 'false';
                        break;
                }

                return memo + ';' + keyMap[key] + '=' + data;
            }, '')
            .tap(encodeURI)
            .value().substring(1);
    };
    Flights.completeLocations = function(orig, dest) {
        return _.isObject(orig) && _.isObject(dest) &&
            orig.searchSegments.length === dest.searchSegments.length &&
            _.every(orig.searchSegments, function(s, i) {
                var seg = dest.searchSegments[i];
                if (_.matches(seg.departure)(s.departure) &&
                    _.matches(seg.destination)(s.destination)) {
                    seg.departure = s.departure;
                    seg.destination = s.destination;
                    return true;
                } else {
                    return false;
                }
            });
    };

    function isDpFlightsResults(currentPage) {
        return /^(dpresults|dpresults_flights)$/.test(currentPage);
    }

    Flights.isDpFlightsResults = isDpFlightsResults;

    Flights.getSearchData = function(params, currentPage, paramsParserFun) {
        var urlParameters = null;
        var pageStorage = null;
        var geoDfd;
        var searchParamsParser = _.isFunction(paramsParserFun) ? paramsParserFun : Flights.searchParamsParser;
        var directUrlBuyPath = isDpFlightsResults(currentPage) ? App.Dynpack.getMobileBuyPath() :
            'inspirational' === currentPage ? 'INSPIRATIONAL_SEARCH' : 'FLIGHTS_DIRECT_URL';
        var getDirectUrlBuyPath = function() {
            Odigeo.Session.set('dpForceNewSearch', 'true');
            return directUrlBuyPath;
        };
        var composeSearchData = function(urlParametersFullFilled) {
            // Check if searching from previous page
            pageStorage = Odigeo.Session.get('searchParameters');

            if (!_.isNull(pageStorage)) {
                try {
                    pageStorage = JSON.parse(pageStorage);
                } catch (e) {
                    pageStorage = null;
                }
            }

            if (!_.isEmpty(params)) {
                urlParameters = searchParamsParser(params);
            }

            if (_.isNull(urlParameters)) {
                if (_.isEmpty(pageStorage)) {
                    return $.Deferred().reject('NO_SEARCH');
                }
                return $.Deferred().resolve(pageStorage);
            } else if (urlParametersFullFilled && Flights.completeLocations(pageStorage, urlParameters)) {
                urlParameters.buyPath = urlParameters.buyPath || getDirectUrlBuyPath();
                return $.Deferred().resolve(urlParameters);
            } else if (!_.isNull(pageStorage) && Flights.completeLocations(pageStorage, urlParameters)) {
                urlParameters.buyPath = urlParameters.buyPath || pageStorage.buyPath;
                return $.Deferred().resolve(urlParameters);
            } else {
                urlParameters.buyPath = urlParameters.buyPath || getDirectUrlBuyPath();
                geoDfd = Flights.completeWithGeographicInformation(urlParameters);
                return geoDfd;
            }
        };

        if (!_.isEmpty(params) && -1 === params.toString().indexOf('type=M') && -1 === params.toString().indexOf('from.') &&
            -1 === params.toString().indexOf('from=') && ('results' === currentPage || 'flights' === currentPage)) {
            var defer = $.Deferred();

            if (navigator.geolocation && 'desktop' !== Odigeo.SessionScope.flow) {
                App.Flights.getClosestAirports().done(function(data) {
                    var values = data;
                    var value;
                    var selected = values.airports[0] || values.cities[0] || false;

                    if (selected) {
                        value = _.extend(_.pick(selected, [
                            'city',
                            'text',
                            'geoNodeId',
                            'iata',
                            'country',
                            'countryCode',
                            'name',
                            'type',
                        ]));

                        params += ';from=' + value.iata + ';';
                    }
                }).done(function() {
                    composeSearchData(true).then(function(data) {
                        defer.resolve(data);
                    }, function() {
                        defer.reject('NO_SEARCH');
                    });
                }).fail(function() {
                    if ('flights' === currentPage) {
                        if (!_.isEmpty(params)) {
                            urlParameters = searchParamsParser(params);
                        }
                        urlParameters.buyPath = getDirectUrlBuyPath();
                        Flights.completeWithGeographicInformation(urlParameters).then(function(data) {
                            defer.resolve(data);
                        }, function(data) {
                            defer.reject(data);
                        });
                    } else {
                        var depDate;
                        var paramsData = {};
                        var s = [];

                        _.each(params.split(';'), function(a) {
                            var s = a.split('=');
                            paramsData[s[0]] = s[1];
                        });

                        if (_.has(paramsData, 'dep')) {
                            depDate = paramsData['dep'];
                        } else if (_.has(paramsData, 'X')) {
                            depDate = Flights.composeParametrizedDate('dep', paramsData['X']);
                            paramsData['dep'] = depDate;
                            delete paramsData['X'];
                        }

                        if (_.has(paramsData, 'Y')) {
                            paramsData['ret'] = Flights.composeParametrizedDate('ret', paramsData['Y'], depDate);
                            delete paramsData['Y'];
                        }

                        _.each(paramsData, function(value, key) {
                            if (value !== undefined) {
                                s[s.length] = key + '=' + value;
                            }
                        });
                        Odigeo.Router.navigate('home', {replace: true,
params: s.join(';')});
                    }
                });
            }
            return defer.promise();
        } else {
            return composeSearchData();
        }
    };

    Flights.purgePreviousSearches = function(raw) {
        var data;
        if (raw) {
            try {
                data = JSON.parse(raw);
            } catch (e) {
                data = [];
            }
        } else {
            data = [];
        }

        if (tv4.validate(data, App.Flights.Schemas.searchDataSchema)) {
            _.each(data, function(search, idx) {
                if (!tv4.validate(search, App.Flights.Schemas.searchData)) {
                    delete data[idx];
                }
            });
            data = _.compact(data);
        } else {
            data = [];
        }

        return data;
    };

    Flights.purgeTravellers = function(raw) {
        var data;

        if (raw) {
            try {
                data = JSON.parse(raw);
            } catch (e) {
                data = {};
            }
        } else {
            data = {};
        }

        if (tv4.validate(data, App.Flights.Schemas.travellersSchema)) {
            for (var type in data) {
                if (data[type]) {
                    for (var key in data[type]) {
                        if ('defaultTraveler' !== type) {
                            if ('adults' === type) {
                                if (!tv4.validate(data[type][key], App.Flights.Schemas.travellerAdults)) {
                                    delete data[type][key];
                                }
                            } else {
                                if (!tv4.validate(data[type][key], App.Flights.Schemas.travellerChildren)) {
                                    delete data[type][key];
                                }
                            }
                        }
                    }
                }
            }
        } else {
            data = {'adults': {},
                'children': {},
                'infants': {}};
        }
        return data;
    };

    Flights.checkCookies = function() {
        if (!Odigeo.Device.navigator.hasCookies) {
            var button = {
                text: Odigeo.UIElements.translations.errCookies.button,
                style: 'od-ui-dialog-button-default',
                handler: function() {
                    window.location.reload();
                },
            };
            var noCookiesDialog = Odigeo.UIElements.createDialog({
                headerText: Odigeo.UIElements.translations.errCookies.text,
                content: Odigeo.UIElements.translations.errCookies.content,
                buttons: [button],
                dialogClasses: 'dialog_error',
            });

            Odigeo.UIElements.showDialog(noCookiesDialog);
        }
        return Odigeo.Device.navigator.hasCookies;
    };

    Flights.roomSetUpMap = {
        '1-0-0': ['1_0_0'],
        '1-0-1': ['1_0_1'],
        '1-0-2': ['1_0_2'],
        '1-1-0': ['1_1_0'],
        '1-1-1': ['1_1_1'],
        '1-2-0': ['1_2_0'],
        '2-0-0': ['2_0_0'],
        '2-0-1': ['2_0_1'],
        '2-0-2': ['2_0_2'],
        '2-1-0': ['2_1_0'],
        '2-1-1': ['2_1_1'],
        '2-1-2': ['1_0_2', '1_1_0'],
        '2-2-0': ['2_2_0'],
        '2-2-1': ['1_1_0', '1_1_1'],
        '2-2-2': ['1_2_0', '1_0_2'],
        '2-3-0': ['1_2_0', '1_1_0'],
        '2-3-1': ['1_2_0', '1_1_1'],
        '2-4-0': ['1_2_0', '1_2_0'],
        '3-0-0': ['3_0_0'],
        '3-0-1': ['3_0_1'],
        '3-0-2': ['2_0_2', '1_0_0'],
        '3-1-0': ['2_0_0', '1_1_0'],
        '3-1-1': ['2_0_1', '1_1_0'],
        '3-1-2': ['2_1_1', '1_0_1'],
        '3-2-0': ['2_1_0', '1_1_0'],
        '3-2-1': ['2_1_0', '1_1_1'],
        '3-2-2': ['2_1_1', '1_1_1'],
        '3-2-3': ['1_0_1', '1_1_1', '1_1_1'],
        '3-3-0': ['2_2_0', '1_1_0'],
        '3-3-1': ['2_2_0', '1_1_1'],
        '3-3-2': ['1_1_1', '1_1_1', '1_1_0'],
        '3-4-0': ['2_2_0', '1_2_0'],
        '3-4-1': ['1_2_0', '1_2_0', '1_0_1'],
        '3-4-2': ['1_2_0', '1_2_0', '1_0_2'],
        '3-5-0': ['1_2_0', '1_2_0', '1_1_0'],
        '3-5-1': ['1_2_0', '1_2_0', '1_1_1'],
        '3-6-0': ['1_2_0', '1_2_0', '1_2_0'],
        '4-0-0': ['2_0_0', '2_0_0'],
        '4-0-1': ['2_0_0', '2_0_1'],
        '4-0-2': ['2_0_1', '2_0_1'],
        '4-1-0': ['2_1_0', '2_0_0'],
        '4-1-1': ['2_1_0', '2_0_1'],
        '4-1-2': ['2_1_1', '2_0_1'],
        '4-2-0': ['2_1_0', '2_1_0'],
        '4-2-1': ['2_1_0', '2_1_1'],
        '4-2-2': ['2_1_1', '2_1_1'],
        '4-3-0': ['2_2_0', '2_1_0'],
        '4-3-1': ['2_2_0', '2_1_1'],
        '4-3-2': ['2_1_0', '1_2_0', '1_0_2'],
        '4-4-0': ['2_2_0', '2_2_0'],
        '4-4-1': ['2_0_1', '1_2_0', '1_2_0'],
        '4-5-0': ['2_2_0', '1_2_0', '1_1_0'],
        '5-0-0': ['3_0_0', '2_0_0'],
        '5-0-1': ['3_0_0', '2_0_1'],
        '5-0-2': ['2_0_1', '2_0_1', '1_0_0'],
        '5-1-0': ['3_0_0', '2_1_0'],
        '5-1-1': ['3_0_0', '2_1_1'],
        '5-1-2': ['2_0_1', '2_1_1', '1_0_0'],
        '5-2-0': ['3_1_0', '2_1_0'],
        '5-2-1': ['3_1_0', '2_1_1'],
        '5-2-2': ['2_1_1', '2_1_1', '1_0_0'],
        '5-3-0': ['3_1_0', '2_2_0'],
        '5-3-1': ['2_1_1', '2_2_0', '1_0_0'],
        '5-4-0': ['2_1_0', '2_1_0', '1_2_0'],
        '6-0-0': ['2_0_0', '2_0_0', '2_0_0'],
        '6-0-1': ['2_0_0', '2_0_0', '2_0_1'],
        '6-0-2': ['2_0_0', '2_0_1', '2_0_1'],
        '6-1-0': ['2_1_0', '2_0_0', '2_0_0'],
        '6-1-1': ['2_1_0', '2_0_0', '2_0_1'],
        '6-1-2': ['2_1_0', '2_0_1', '2_0_1'],
        '6-2-0': ['2_1_0', '2_1_0', '2_0_0'],
        '6-2-1': ['2_1_0', '2_1_0', '2_0_1'],
        '6-3-0': ['2_1_0', '2_1_0', '2_1_0'],
        '7-0-0': ['3_0_0', '2_0_0', '2_0_0'],
        '7-0-1': ['3_0_0', '2_0_0', '2_0_1'],
        '7-0-2': ['3_0_0', '2_0_1', '2_0_1'],
        '7-1-0': ['3_0_0', '2_1_0', '2_0_0'],
        '7-1-1': ['3_0_0', '2_1_0', '2_0_1'],
        '7-2-0': ['3_0_0', '2_1_0', '2_1_0'],
        '8-0-0': ['2_0_0', '2_0_0', '2_0_0', '2_0_0'],
        '8-0-1': ['2_0_0', '2_0_0', '2_0_0', '2_0_1'],
        '8-1-0': ['2_1_0', '2_0_0', '2_0_0', '2_0_0'],
        '9-0-0': ['3_0_0', '3_0_0', '3_0_0'],
    };

    Flights.validateRooms = function(data) {
        var roomSetUp = Flights.roomSetUpMap[data.numAdults + '-' + data.numChildren + '-' + data.numInfants];
        var afterDealRoomSetUp;
        var dealRoomSetUp;
        var configRooms;

        if (_.isUndefined(roomSetUp) && 2 < data.numChildren) {
            dealRoomSetUp = Flights.roomSetUpMap['1-2-0'];
            afterDealRoomSetUp = Flights.roomSetUpMap[(data.numAdults - 1) + '-' + (data.numChildren - 2) + '-' + data.numInfants];
            roomSetUp = !_.isUndefined(afterDealRoomSetUp) ? dealRoomSetUp.concat(afterDealRoomSetUp) : roomSetUp;
        }

        if (_.isUndefined(roomSetUp) && 2 < data.numInfants) {
            configRooms = _.isUndefined(dealRoomSetUp) ? [1, 0] : [2, 2];
            dealRoomSetUp = Flights.roomSetUpMap[configRooms[0] + '-' + configRooms[1] + '-2'];
            afterDealRoomSetUp = Flights.roomSetUpMap[(data.numAdults - configRooms[0]) + '-' +
            (data.numChildren - configRooms[1]) + '-' + (data.numInfants - 2)];
            roomSetUp = !_.isUndefined(afterDealRoomSetUp) ? dealRoomSetUp.concat(afterDealRoomSetUp) : roomSetUp;
        }

        return roomSetUp;
    };

    Flights.getRoomsParams = function(data) {
        var rooms = App.Flights.validateRooms(data);
        var nRooms = _.size(rooms);
        var params = '';

        _.each(rooms, function(room, index) {
            params = params.concat('&q-room-').concat(index).concat('-adults=').concat(room.split('_')[0]);
        });

        return nRooms.toString().concat(params);
    };

    Flights.getDynpackSearchFunction = function(setRoomSetUp, voidFunction, baseUrl) {
        var mode = Odigeo.SessionScope ? Odigeo.SessionScope.dynPackMode : '';

        if (_.isUndefined(voidFunction)) {
            voidFunction = function() {
                return '#';
            };
        }
        if (_.isUndefined(baseUrl)) {
            baseUrl = Odigeo.SessionScope ? Odigeo.SessionScope.dynPackUrlBase : '';
        }

        switch (mode) {
            case 'GO':
            case 'OP':

                return function(data) {
                    var classMap = {
                        BUSINESS: 'aff',
                        FIRST: 'fst',
                        TOURIST: 'eco',
                        PREMIUM_ECONOMY: 'pre',
                    };
                    var params;
                    var defaults = {
                        typ: 'flighthotel',
                        idpart: Odigeo.SessionScope.idpart,
                        locked_iata: '',
                        dpdapi: 'B',

                        rooms: 1,
                        adt0: 2,
                        enf0: 0,
                        ae01: 0,
                        ae02: 0,
                        adt1: 2,
                        enf1: 0,
                        ae11: 0,
                        ae12: 0,
                        adt2: 2,
                        enf2: 0,
                        ae21: 0,
                        ae22: 0,
                        adt3: 2,
                        enf3: 0,
                        ae31: 0,
                        ae32: 0,
                    };

                    if (2 === data.searchSegments.length && 'roundTrip' === data.type) {
                        defaults = setRoomSetUp(data, defaults, mode);
                        params = _.extend(defaults, {
                            vil_dep: data.searchSegments[0].departure.city,
                            iata_dep: data.searchSegments[0].departure.iata,
                            geo_vil_dep: data.searchSegments[0].departure.geoNodeId,

                            vil_arr: data.searchSegments[0].destination.city,

                            dte_dep: data.searchSegments[0].dateStr,
                            dte_ret: data.searchSegments[1].dateStr,

                            cls: classMap[data.cabinClass] || 'eco',

                            direct: data.directFlightsOnly ? 'oui' : 'non',
                        });

                        if (!_.isNull(data.collectionMethod)) {
                            params = _.extend(params, {
                                collectionMethodId: data.collectionMethod,
                            });
                        }

                        if ('OP' === mode && !!data.checkInDate && !!data.checkOutDate) {
                            params = _.extend(params, {
                                htl_arr: Odigeo.Utils.formatDateFromString(data.checkInDate, 'yyyy-mm-dd', 'dd/mm/yyyy'),
                                htl_dep: Odigeo.Utils.formatDateFromString(data.checkOutDate, 'yyyy-mm-dd', 'dd/mm/yyyy'),
                            });
                        }

                        return baseUrl + '?' + $.param(params);
                    } else {
                        return voidFunction;
                    }
                };

            // 'ED' or anything else
            default:

                return function(data) {
                    var params;
                    var defaults = {
                        action: 'engine/DynPackSearch/search',
                        buyPath: 95,
                        auxOrBt: 0,
                        searchMainProductTypeName: 'DYNPACK',

                        departureTime: '0000',
                        returnTime: '0000',

                        numberOfRooms: 1,
                        room0Adults: 2,
                        room1Adults: 2,
                        room2Adults: 2,
                        room3Adults: 2,
                        room0Childs: 0,
                        room0Child0Age: 0,
                        room0Child1Age: 0,
                        room1Childs: 0,
                        room1Child0Age: 0,
                        room1Child1Age: 0,
                        room2Childs: 0,
                        room2Child0Age: 0,
                        room2Child1Age: 0,
                        room3Childs: 0,
                        room3Child0Age: 0,
                        room3Child1Age: 0,
                    };

                    if (2 === data.searchSegments.length && 'roundTrip' === data.type) {
                        defaults = setRoomSetUp(data, defaults, mode);
                        params = _.extend(defaults, {
                            departureLocation: data.searchSegments[0].departure.name,
                            departureDate: data.searchSegments[0].dateStr.split('-').reverse().join('/'),
                            arrivalLocation: data.searchSegments[0].destination.name,
                            departureLocationGeoNodeId: data.searchSegments[0].departure.geoNodeId,
                            arrivalLocationGeoNodeId: data.searchSegments[0].destination.geoNodeId,
                            returnDate: data.searchSegments[1].dateStr.split('-').reverse().join('/'),
                            filterDirectFlights: data.directFlightsOnly,
                        });
                        if (!_.isNull(data.collectionMethod)) {
                            params = _.extend(params, {
                                collectionMethodId: data.collectionMethod,
                            });
                        }

                        if (!!data.checkInDate && !!data.checkOutDate) {
                            params = _.extend(params, {
                                accommodationCheckInDate: Odigeo.Utils.formatDateFromString(data.checkInDate, 'yyyy-mm-dd', 'dd/mm/yyyy'),
                                accommodationCheckOutDate: Odigeo.Utils.formatDateFromString(data.checkOutDate, 'yyyy-mm-dd', 'dd/mm/yyyy'),
                            });
                        }

                        return baseUrl + '?' + $.param(params);
                    } else {
                        return voidFunction;
                    }
                };
        }
    };

    Flights.parseDynpackParams = function(data, defaults, mode) {
        var i;
        var j;
        var k;
        var rooms = data.rooms;
        var roomChildren;
        var roomInfants;
        var numberOfRooms = data.numberOfRooms;

        defaults[Flights.getNumberOfRoomsItem(mode)] = numberOfRooms;
        for (i = 0; i < numberOfRooms; i++) {
            roomChildren = rooms['roomKids' + i];
            roomInfants = rooms['roomInfants' + i];
            defaults[Flights.getRoomConfigItem(true, i, mode)] = rooms['roomAdults' + i];
            defaults[Flights.getRoomConfigItem(false, i, mode)] = roomChildren + roomInfants;
            for (j = 0; j < roomChildren; j++) {
                defaults[Flights.getRoomChildAge(i, j, mode)] = rooms['room' + i + 'Kid' + j + 'Age'];
            }
            for (k = 0; k < roomInfants; k++) {
                defaults[Flights.getRoomChildAge(i, k + j, mode)] = rooms['room' + i + 'Infant' + k + 'Age'];
            }
        }
        return defaults;
    };

    Flights.getRoomConfigItem = function(isAdult, index, mode) {
        switch (mode) {
            case 'GO':
            case 'OP':
                return (isAdult ? 'adt' : 'enf') + index;
            // 'ED' or anything else
            default:
                return 'room' + index + (isAdult ? 'Adults' : 'Childs');
        }
    };

    Flights.getRoomChildAge = function(room, child, mode) {
        switch (mode) {
            case 'GO':
            case 'OP':
                return 'ae' + (child + 1) + room;
            // 'ED' or anything else
            default:
                return 'room' + room + 'Child' + child + 'Age';
        }
    };

    Flights.getNumberOfRoomsItem = function(mode) {
        switch (mode) {
            case 'GO':
            case 'OP':
                return 'rooms';
            // 'ED' or anything else
            default:
                return 'numberOfRooms';
        }
    };

    Flights.dynpackParamsStringify = (function() {
        var baseUrl = Odigeo.SessionScope ? Odigeo.SessionScope.dynPackUrlBase : '';
        var voidFunction = function() {
            return '#';
        };
        var setRoomSetUp = function(data, defaults, mode) {
            var roomSetUp = Flights.validateRooms(data);
            var i;
            var j;
            var k;
            var numberOfRooms = roomSetUp.length;
            var roomItemSetUp;
            var roomChildren;
            var roomInfants;

            defaults[Flights.getNumberOfRoomsItem(mode)] = numberOfRooms;
            for (i = 0; i < numberOfRooms; i++) {
                roomItemSetUp = roomSetUp[i].split('_');
                roomChildren = parseInt(roomItemSetUp[1], 10);
                roomInfants = parseInt(roomItemSetUp[2], 10);
                defaults[Flights.getRoomConfigItem(true, i, mode)] = parseInt(roomItemSetUp[0], 10);
                defaults[Flights.getRoomConfigItem(false, i, mode)] = roomChildren + roomInfants;
                for (j = 0; j < roomChildren; j++) {
                    defaults[Flights.getRoomChildAge(i, j, mode)] = 6;
                }
                for (k = roomChildren; k < (roomChildren + roomInfants); k++) {
                    defaults[Flights.getRoomChildAge(i, k, mode)] = 1;
                }
            }
            return defaults;
        };

        if (!baseUrl) {
            return voidFunction;
        }

        return Flights.getDynpackSearchFunction(setRoomSetUp, voidFunction, baseUrl);
    })();

    Flights.getClosestAirports = function() {
        return Odigeo.Device.location.get()
            .then(function(pos) {
                var geoUrl = Odigeo.Settings.property('geoServiceUrlFormatter')('geocomplete') +
                    ';latitude=' + pos.coords.latitude +
                    ';longitude=' + pos.coords.longitude;

                return $.ajax({url: geoUrl});
            });
    };
}());
